import { Component, input, output } from '@angular/core';
import { IconComponent, TooltipComponent, TypographyComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe } from '../../../../core/i18n';
import type { PackageTypeId, PackageTypeOption } from '../../package-types.config';

/**
 * Renders the data-driven package type radio cards for the Package step.
 */
@Component({
  selector: 'app-package-type-selector',
  imports: [IconComponent, TooltipComponent, TypographyComponent, TranslatePipe],
  templateUrl: './package-type-selector.html',
  styleUrl: './package-type-selector.scss',
})
export class PackageTypeSelector {
  readonly packageTypes = input.required<readonly PackageTypeOption[]>();
  readonly selectedId = input<PackageTypeId | null>(null);
  readonly packageTypeChange = output<PackageTypeId>();
  readonly howToMeasureRequested = output<void>();

  /**
   * Selects a package type when its radio card is activated.
   */
  protected onSelect(typeId: PackageTypeId): void {
    this.packageTypeChange.emit(typeId);
  }

  /**
   * Opens the how-to-measure dialog without changing the package type selection.
   */
  protected onHowToMeasure(event: Event): void {
    event.stopPropagation();
    this.howToMeasureRequested.emit();
  }
}
